export const countries = [
  { code: "US", name: "Estados Unidos" },
  { code: "ES", name: "España" },
  { code: "MX", name: "Mexico" },
  { code: "AR", name: "Argentina" },
  { code: "CO", name: "Colombia" },
  { code: "CL", name: "Chile" },
  { code: "PE", name: "Peru" },
  { code: "BR", name: "Brasil" },
  { code: "DE", name: "Alemania" },
  { code: "FR", name: "Francia" },
  { code: "GB", name: "Reino Unido" },
  { code: "IT", name: "Italia" },
  { code: "PT", name: "Portugal" },
  { code: "NL", name: "Paises Bajos" },
  { code: "BE", name: "Belgica" },
  { code: "CH", name: "Suiza" },
  { code: "AT", name: "Austria" },
  { code: "CA", name: "Canada" },
  { code: "JP", name: "Japon" },
  { code: "CN", name: "China" },
  { code: "IN", name: "India" },
  { code: "AU", name: "Australia" },
  { code: "NZ", name: "Nueva Zelanda" },
  { code: "KR", name: "Corea del Sur" },
  { code: "SG", name: "Singapur" },
  { code: "AE", name: "Emiratos Arabes Unidos" },
  { code: "SA", name: "Arabia Saudita" },
  { code: "ZA", name: "Sudafrica" },
  { code: "NG", name: "Nigeria" },
  { code: "EG", name: "Egipto" },
  { code: "TR", name: "Turquia" },
  { code: "PL", name: "Polonia" },
  { code: "SE", name: "Suecia" },
  { code: "NO", name: "Noruega" },
  { code: "DK", name: "Dinamarca" },
  { code: "FI", name: "Finlandia" },
  { code: "CZ", name: "Republica Checa" },
  { code: "HU", name: "Hungria" },
  { code: "GR", name: "Grecia" },
  { code: "IE", name: "Irlanda" },
  { code: "LU", name: "Luxemburgo" },
  { code: "IS", name: "Islandia" },
  { code: "RU", name: "Rusia" },
  { code: "UA", name: "Ucrania" },
  { code: "RO", name: "Rumania" },
  { code: "BG", name: "Bulgaria" },
  { code: "HR", name: "Croacia" },
  { code: "SI", name: "Eslovenia" },
  { code: "SK", name: "Eslovaquia" },
  { code: "EE", name: "Estonia" },
  { code: "LV", name: "Letonia" },
  { code: "LT", name: "Lituania" },
  { code: "VE", name: "Venezuela" },
  { code: "EC", name: "Ecuador" },
  { code: "BO", name: "Bolivia" },
  { code: "PY", name: "Paraguay" },
  { code: "UY", name: "Uruguay" },
  { code: "CR", name: "Costa Rica" },
  { code: "PA", name: "Panama" },
  { code: "DO", name: "Republica Dominicana" },
  { code: "GT", name: "Guatemala" },
  { code: "CU", name: "Cuba" },
  { code: "HT", name: "Haiti" },
  { code: "PR", name: "Puerto Rico" },
  { code: "JM", name: "Jamaica" },
  { code: "IL", name: "Israel" },
  { code: "QA", name: "Qatar" },
  { code: "KW", name: "Kuwait" },
  { code: "BH", name: "Bahrein" },
  { code: "OM", name: "Oman" },
  { code: "ID", name: "Indonesia" },
  { code: "MY", name: "Malasia" },
  { code: "TH", name: "Tailandia" },
  { code: "VN", name: "Vietnam" },
  { code: "PH", name: "Filipinas" },
  { code: "HK", name: "Hong Kong" },
  { code: "TW", name: "Taiwan" },
  { code: "PK", name: "Pakistan" },
  { code: "BD", name: "Bangladesh" },
  { code: "LK", name: "Sri Lanka" },
  { code: "NP", name: "Nepal" },
  { code: "MM", name: "Birmania" },
  { code: "KH", name: "Camboya" },
  { code: "LA", name: "Laos" },
  { code: "FJ", name: "Fiyi" },
];
